import React from "react";
import { Box, Typography, Paper } from "@mui/material";

const DialogFrame = () => {
  return (
    <Box>
      <Typography variant="h4" gutterBottom>
        Dialog Frame
      </Typography>
      <Paper elevation={2} sx={{ p: 2 }}>
        <Typography>
          This is the DialogFrame component. Replace this with your actual UI.
        </Typography>
      </Paper>
    </Box>
  );
};

export default DialogFrame;
